var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsappSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.25,
    height: 25.25
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5748",
    fill: "#555",
    stroke: "#555",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2651",
    d: "M12.625.126A12.5 12.5 0 002.018 19.242c-.494 1.73-1.386 5-1.4 5.036a.481.481 0 00.605.586l4.955-1.524A12.5 12.5 0 1012.625.126zm0 24.038a11.51 11.51 0 01-6.121-1.755.481.481 0 00-.255-.073.489.489 0 00-.141.021l-4.327 1.332c.318-1.16.889-3.235 1.22-4.389a.482.482 0 00-.059-.395 11.54 11.54 0 119.682 5.26z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2652",
    d: "M19.907 15.232a29.49 29.49 0 01-1.951-1.2c-.374-.244-.645-.421-.843-.521a.971.971 0 00-1.134.08.428.428 0 00-.053.065 6.008 6.008 0 01-1.549 1.737 10.291 10.291 0 01-2.628-1.7 5.69 5.69 0 01-2.079-2.627c.775-.8 1.054-1.3 1.054-1.87a12.1 12.1 0 00-1.621-3.293c-.249-.249-.81-.288-1.668-.117a.432.432 0 00-.218.117c-.1.1-2.534 2.582-1.379 5.585 1.268 3.3 4.522 7.127 8.67 7.749a8.99 8.99 0 001.327.106 3.935 3.935 0 004.286-3.664.426.426 0 00-.214-.447zm-5.273 3.156c-4.387-.658-7.15-5-8-7.211-.842-2.188.711-4.14 1.1-4.581a3.224 3.224 0 01.79-.055 15.351 15.351 0 011.343 2.652c0 .224-.073.537-.943 1.407a.426.426 0 00-.125.3c0 2.238 4.72 5.343 5.556 5.343.727 0 1.675-1.222 2.215-2.018a.405.405 0 01.159.05c.154.077.421.251.758.472.445.291 1.037.677 1.735 1.078-.316 1.528-1.202 3.072-4.588 2.563z"
  }))));
}

export default __webpack_public_path__ + "static/media/whatsapp_sm.4a533389bb606965253f75980870421b.svg";
export { SvgWhatsappSm as ReactComponent };